<template>
  <div>
    <base-header class="pb-6" type="default">
      <b-row align-v="center" class="py-4">
        <b-col>
          <p class="h2 text-white d-inline-block mb-0">Filtres</p>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <RouteBreadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6 pb-4">
      <b-row>
        <b-col>
          <FilterGroupForm title="Ajouter une catégorie de filtre" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { BaseHeader, RouteBreadcrumb } from '@coop-zone/coop-zone-argon'
import FilterGroupForm from '@/components/Filters/FilterGroupForm'

export default {
  components: {
    BaseHeader,
    RouteBreadcrumb,
    FilterGroupForm,
  },
}
</script>
